/** Authorization failures may have no JSON body; preserve the HTTP error in that case. */
export const getVehicleRemovalError = async (response) => {
    const messages = {
        401: 'Your session has expired. Sign in again before removing a vehicle.',
        403: 'Removal denied. System Admin, UBI Access and company membership are required.',
        404: 'The vehicle was not found within your company or is no longer available for removal.',
    };
    const fallback = messages[response.status] || `Vehicle removal failed (HTTP ${response.status}).`;
    let body;
    try {
        body = await response.text();
    } catch {
        return fallback;
    }
    if (!body.trim()) return fallback;

    try {
        const error = JSON.parse(body);
        if (typeof error === 'string') return error || fallback;
        return error?.errorMessage || error?.detail || error?.title || fallback;
    } catch {
        // Proxies can return HTML error pages instead of the API's JSON response.
        if (body.trim().startsWith('<')) return fallback;
        return body;
    }
};
